import { IGraphDataPoint } from "../../../../shared/scripts/graphing/graphing.entities";
import { GetDateFromString } from "../../../../shared/scripts/date-functions";

export class FinancialSpendEntry {
    ID: string;
    Deliverable: string;
    Category: string;
    Unit_Desc: string;
    units_budgeted: number;
    Latest_Invoice: string;
    Billed_to_Date: number;
    cost_budgeted: number;
    est_spending: number;
    est_units: number;
    Overspending_Units: number;
    Overspending_Cost: number;
    source: string;
    isOverspent: boolean;
    Platform: string;
    IdSort: number;


    Billed_to_Date_Display: string;
    cost_budgeted_Display: string;
    est_spending_Display: string;
    Overspending_Cost_Display: string;
    AllPlatformsDisplay: string;
    CategorySort: number;
    units_budgeted_Display: string;
    est_units_Display: string;
    Overspending_Units_Display: string
    Category_Display: string;
    isOverspent_Display: string;

    initialize(): void {
        this.Overspending_Cost = Math.round(this.Overspending_Cost);
        const result = this.ID.replace(/[a-zA-Z]/g, '');
        this.IdSort = parseFloat(result);

        this.Billed_to_Date_Display = this.displayCurrency(Math.round(this.Billed_to_Date));
        this.cost_budgeted_Display = this.displayCurrency(Math.round(this.cost_budgeted));
        this.est_spending_Display = this.displayCurrency(Math.round(this.est_spending));
        this.Overspending_Cost_Display = this.displayCurrency(Math.round(this.Overspending_Cost));
        this.units_budgeted_Display = this.displayUnits(this.units_budgeted);
        this.est_units_Display = this.displayUnits(this.est_units);
        this.Overspending_Units_Display = this.displayUnits(this.Overspending_Units);
        this.AllPlatformsDisplay = `<span style="cursor: pointer"><i class="fa-solid fa-arrow-up-right-from-square"></i>  ${this.Platform}</span>`;
        this.Category_Display = `<span style="cursor: pointer; text-decoration: underline; font-weight: bold;">${this.Category}</span>`;
        if (this.CategorySort != 1) {
            this.CategorySort = 2;
        }
        if (this.isOverspent) {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square-check"></i></span>`;
        }
        else {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square"></i></span>`;
        }
    }

    displayCurrency(amount: number) {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0, // No decimal places
            maximumFractionDigits: 0, // No decimal places
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return USDollar.format(amount);
        }
    }

    displayUnits(amount: number) {
        let numberFormatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return numberFormatter.format(amount);
        }
    }


}

export class HistoricalFinancialSpendEntry {
    ID: string;
    Deliverable: string;
    Category: string;
    Unit_Desc: string;
    units_budgeted: number;
    Latest_Invoice: string;
    Billed_to_Date: number;
    cost_budgeted: number;
    est_spending: number;
    est_units: number;
    Overspending_Units: number;
    Overspending_Cost: number;
    source: string;
    isOverspent: boolean;
    Platform: string;
    IdSort: number;
    Estimation_Date: string;


    Billed_to_Date_Display: string;
    cost_budgeted_Display: string;
    est_spending_Display: string;
    Overspending_Cost_Display: string;
    AllPlatformsDisplay: string;
    CategorySort: number;
    units_budgeted_Display: string;
    est_units_Display: string;
    Overspending_Units_Display: string
    Category_Display: string;
    isOverspent_Display: string;

    initialize(): void {
        this.Overspending_Cost = Math.round(this.Overspending_Cost);
        const result = this.ID.replace(/[a-zA-Z]/g, '');
        this.IdSort = parseFloat(result);

        this.Billed_to_Date_Display = this.displayCurrency(Math.round(this.Billed_to_Date));
        this.cost_budgeted_Display = this.displayCurrency(Math.round(this.cost_budgeted));
        this.est_spending_Display = this.displayCurrency(Math.round(this.est_spending));
        this.Overspending_Cost_Display = this.displayCurrency(Math.round(this.Overspending_Cost));
        this.units_budgeted_Display = this.displayUnits(this.units_budgeted);
        this.est_units_Display = this.displayUnits(this.est_units);
        this.Overspending_Units_Display = this.displayUnits(this.Overspending_Units);
        this.AllPlatformsDisplay = `<span style="cursor: pointer"><i class="fa-solid fa-arrow-up-right-from-square"></i>  ${this.Platform}</span>`;
        this.Category_Display = `<span style="cursor: pointer; text-decoration: underline; font-weight: bold;">${this.Category}</span>`;
        if (this.CategorySort != 1) {
            this.CategorySort = 2;
        }
        if (this.isOverspent) {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square-check"></i></span>`;
        }
        else {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square"></i></span>`;
        }

        let dateObject: Date = GetDateFromString(this.Estimation_Date, "slash-month-day-year");
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth();

        dateObject = new Date(year, month + 1, 0);

        const mm = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(dateObject.getDate()).padStart(2, '0');
        const yyyy = dateObject.getFullYear();
        let newDate = mm + "/" + dd + "/" + yyyy;
        this.Estimation_Date = newDate;

    }

    displayCurrency(amount: number) {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0, // No decimal places
            maximumFractionDigits: 0, // No decimal places
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return USDollar.format(amount);
        }
    }

    displayUnits(amount: number) {
        let numberFormatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return numberFormatter.format(amount);
        }
    }


}

export class CumulativeInvoiceEntry {
    ID: string;
    Deliverable: string;
    Category: string;
    Date: string;
    Platform: string;

    CumulativeUnits: number;
    CumulativeSpend: number;

   

    initialize(): void {

        let dateObject: Date = GetDateFromString(this.Date, "slash-month-day-year");
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth();

        dateObject = new Date(year, month + 1, 0);

        const mm = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(dateObject.getDate()).padStart(2, '0');
        const yyyy = dateObject.getFullYear();
        let newDate = mm + "/" + dd + "/" + yyyy;
        this.Date = newDate;
    }


}

export class InvoicedGraphDataPoint implements IGraphDataPoint {

    Count: number;

    TimeStamp: number;

    initialize(cumulativeInvoiceItem: CumulativeInvoiceEntry): void {

        this.Count = cumulativeInvoiceItem.CumulativeSpend;
        

        let projDate: Date = GetDateFromString(cumulativeInvoiceItem.Date, "slash-month-day-year");
        this.TimeStamp = projDate.getTime();
    }

    getTimestamp(): number {
        return this.TimeStamp;
    }

    getCount(): number {
        return this.Count;

    }
}


export class EstimatedGraphDataPoint implements IGraphDataPoint {

    Count: number;

    TimeStamp: number;

    initialize(historicSpendItem: HistoricalFinancialSpendEntry): void {

        this.Count = historicSpendItem.est_spending;

        let projDate: Date = GetDateFromString(historicSpendItem.Estimation_Date, "slash-month-day-year");
        this.TimeStamp = projDate.getTime();
    }

    getTimestamp(): number {
        return this.TimeStamp;
    }

    getCount(): number {
        return this.Count;

    }
}